import { useTranslation } from 'react-i18next';
import Flyout from '@/components/common/Flyout';
import { FlyoutMenuItem } from '@/components/common/Flyout/item';
import useChangeGroupMemberRole from '@/hooks/groups/use-change-group-member-role';
import type { GroupMember } from '@/models/group/group-info';

interface Props {
  show: boolean;
  groupId: number;
  selectedMember: GroupMember | null;
  onClose: () => void;
}

export default function AddGroupAdminMenu({ show, groupId, selectedMember, onClose }: Props) {
  const { t } = useTranslation();
  const { mutateAsync: changeGroupMemberRole } = useChangeGroupMemberRole(groupId);

  if (!selectedMember) return null;

  return (
    <Flyout
      show={show}
      onClose={onClose}>
      <div className='flex flex-col items-stretch gap-2 font-normal'>
        <FlyoutMenuItem
          label={t('conversation.setting.group.admin.to-admin')}
          onClick={() => changeGroupMemberRole({ userId: selectedMember.UserID, role: 9 })}
        />

        <FlyoutMenuItem
          className='mt-2 text-base font-semibold text-[#007AFF]'
          label={t('common.cancel')}
          onClick={onClose}
        />
      </div>
    </Flyout>
  );
}
